import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';
import { createTrackedFetch, isOutageStatus, setBackendProbe } from './backendStatus';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// A one-row read that needs Postgres to answer. Any non-outage status counts, even a 401:
// PostgREST had to reach the database to refuse it.
setBackendProbe(async () => {
  const response = await fetch(`${supabaseUrl}/rest/v1/programs?select=id&limit=1`, {
    headers: { apikey: supabaseAnonKey },
  });
  return !isOutageStatus(response.status);
});

export const supabase = createClient<Database>(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
      debug: false
    },
    global: {
      headers: {
        'Cache-Control': 'no-cache',
        'x-application-name': 'bhcs'
      },
      // Feeds BackendOutageScreen. Looked up per call so tests that stub fetch still see theirs.
      fetch: createTrackedFetch((input, init) => fetch(input, init))
    }
  }
);

// Expose Supabase client to window for debugging
declare global {
  interface Window {
    supabase: typeof supabase;
  }
}

window.supabase = supabase;